import React from 'react';
import tw from 'twin.macro';
import styled, { css } from 'styled-components';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

const ButtonStyles = css`
  ${tw`
    inline-block relative leading-9 text-2xl text-center no-underline
    cursor-pointer z-10 font-bold
  `}
  transition: all 150ms ${(p) => p.theme.easing};
  color: ${(p) => p.theme.color.white};
  min-width: 7rem;
  &:hover, &:focus {
    color: ${(p) => p.theme.color.active};
  }
  &:focus:not(.focus-visible) {
    outline: none;
  }
  ${(p) => p.primaryButton
    && css`
      color: ${(props) => props.theme.color.primary};
    `};
`;

export const Button = styled.button`
  ${ButtonStyles}
`;

export const LinkButton = styled((p) => {
  const { primaryButton, ...rest } = p;
  return (
    <AnchorLink {...rest} />
  );
})`
  ${ButtonStyles}
`;

export const SiteLink = styled(AnchorLink)`
  ${tw`
    relative flex items-center self-stretch m-0 z-10
  `}
  transition: all 150ms ${(p) => p.theme.easing};
`;
